/**
 * 産廃回収からの受注登録
 */
import Vue from 'vue'
import * as httpConst from '../../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/accepts/collections`
const orders_accepts_collection_registration = {
  namespaced: true,
  actions: {
    /**
     * 編集情報取得
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/registrations/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
  }
}
export default orders_accepts_collection_registration
